(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      // this.setHeaderHeight();

      // window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    // setHeaderHeight() {
    //   document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    // }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reseller-account"] && !Shopify.designMode) return;
  try {
    
  class ResellerAccount extends HTMLElement {
    connectedCallback() {
      this.endpoint = this.dataset.endpoint;
      this.companyId = this.dataset.companyId;
      this.customerId = this.dataset.customerId;
      this.errorEl = this.querySelector("[data-error]");
      try { this.i18n = JSON.parse(this.querySelector("[data-reseller-i18n]").textContent); } catch (e) { this.i18n = {}; }

      this.querySelectorAll("[data-remove-location]").forEach((btn) => {
        btn.addEventListener("click", () => this.removeLocation(btn.getAttribute("data-location-id"), btn));
      });
      const addBtn = this.querySelector("[data-add-submit]");
      if (addBtn) addBtn.addEventListener("click", () => this.addLocation(addBtn));

      this.setupProvinces();
    }

    setupProvinces() {
      const country = this.querySelector("[data-country]");
      const province = this.querySelector("[data-province]");
      if (!country || !province) return;
      const REGIONS = {
        CA: [["AB","Alberta"],["BC","British Columbia"],["MB","Manitoba"],["NB","New Brunswick"],["NL","Newfoundland and Labrador"],["NS","Nova Scotia"],["NT","Northwest Territories"],["NU","Nunavut"],["ON","Ontario"],["PE","Prince Edward Island"],["QC","Quebec"],["SK","Saskatchewan"],["YT","Yukon"]],
        US: [["AL","Alabama"],["AK","Alaska"],["AZ","Arizona"],["AR","Arkansas"],["CA","California"],["CO","Colorado"],["CT","Connecticut"],["DE","Delaware"],["DC","District of Columbia"],["FL","Florida"],["GA","Georgia"],["HI","Hawaii"],["ID","Idaho"],["IL","Illinois"],["IN","Indiana"],["IA","Iowa"],["KS","Kansas"],["KY","Kentucky"],["LA","Louisiana"],["ME","Maine"],["MD","Maryland"],["MA","Massachusetts"],["MI","Michigan"],["MN","Minnesota"],["MS","Mississippi"],["MO","Missouri"],["MT","Montana"],["NE","Nebraska"],["NV","Nevada"],["NH","New Hampshire"],["NJ","New Jersey"],["NM","New Mexico"],["NY","New York"],["NC","North Carolina"],["ND","North Dakota"],["OH","Ohio"],["OK","Oklahoma"],["OR","Oregon"],["PA","Pennsylvania"],["RI","Rhode Island"],["SC","South Carolina"],["SD","South Dakota"],["TN","Tennessee"],["TX","Texas"],["UT","Utah"],["VT","Vermont"],["VA","Virginia"],["WA","Washington"],["WV","West Virginia"],["WI","Wisconsin"],["WY","Wyoming"]]
      };
      country.addEventListener("change", () => {
        const list = REGIONS[country.value] || [];
        let html = '<option value="" disabled selected>' + (list.length ? (this.i18n.province_select || "Select a province/state") : (this.i18n.province_first || "Select a country first")) + "</option>";
        for (const r of list) html += '<option value="' + r[0] + '">' + r[1] + "</option>";
        province.innerHTML = html;
      });
    }

    fail(msg) { if (this.errorEl) { this.errorEl.textContent = msg; this.errorEl.hidden = false; } }

    async post(payload, btn) {
      if (this.errorEl) this.errorEl.hidden = true;
      const label = btn ? btn.textContent : "";
      if (btn) { btn.disabled = true; btn.textContent = this.i18n.saving || "Saving…"; }
      try {
        const res = await fetch(this.endpoint, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
        const json = await res.json().catch(() => ({}));
        if (!res.ok || !json.ok) throw new Error(json.error || ("status " + res.status));
        window.location.reload();
      } catch (err) {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        this.fail((this.i18n.err_prefix || "Sorry, that didn't work: ") + (err && err.message ? err.message : "please try again."));
      }
    }

    removeLocation(locationId, btn) {
      if (!locationId) return;
      if (!window.confirm(this.i18n.remove_confirm || "Remove this location?")) return;
      this.post({ op: "remove", companyId: this.companyId, customerId: this.customerId, locationId: locationId }, btn);
    }

    addLocation(btn) {
      const form = this.querySelector("[data-add-form]");
      if (!form) return;
      const get = (name) => { const el = form.querySelector('[name="' + name + '"]'); return el ? el.value.trim() : ""; };
      if (!get("addressAddress1") || !get("addressCity") || !get("addressCountryCode") || !get("addressProvince")) {
        return this.fail(this.i18n.err_fill || "Please fill in the address, city, country and province/state.");
      }
      this.post({
        op: "add",
        companyId: this.companyId,
        customerId: this.customerId,
        name: get("name"),
        addressAddress1: get("addressAddress1"),
        addressCity: get("addressCity"),
        addressProvince: get("addressProvince"),
        addressZip: get("addressZip"),
        addressCountryCode: get("addressCountryCode"),
      }, btn);
    }
  }
  if (!customElements.get("reseller-account")) customElements.define("reseller-account", ResellerAccount);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reseller-hero"] && !Shopify.designMode) return;
  try {
    
  // Smooth-scroll the hero's in-page anchor buttons, offsetting the sticky header.
  document.addEventListener("click", function (e) {
    const link = e.target.closest(".reseller-hero a[href^='#']");
    if (!link) return;
    const id = link.getAttribute("href").slice(1);
    if (!id) return;
    const target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    const header =
      document.querySelector("sticky-header") ||
      document.querySelector(".header-wrapper") ||
      document.querySelector(".shopify-section-group-header-group");
    const offset = (header ? header.offsetHeight : 0) + 12;
    const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: top, behavior: "smooth" });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reseller-qualification"] && !Shopify.designMode) return;
  try {
    
  class ResellerQualification extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector("[data-form]");
      this.steps = Array.from(this.querySelectorAll("[data-step]"));
      this.backBtn = this.querySelector("[data-back]");
      this.nextBtn = this.querySelector("[data-next]");
      this.submitBtn = this.querySelector("[data-submit]");
      this.counter = this.querySelector("[data-counter]");
      this.bar = this.querySelector("[data-progress-bar]");
      this.errorEl = this.querySelector("[data-error]");
      this.successEl = this.querySelector("[data-success]");
      this.index = 0;
      this.storageKey = "amp_reseller_form_v1";
      try { this.i18n = JSON.parse(this.querySelector("[data-reseller-i18n]").textContent); } catch (e) { this.i18n = {}; }
      if (!this.steps.length) return;

      this.nextBtn.addEventListener("click", () => this.next());
      this.backBtn.addEventListener("click", () => this.prev());
      this.form.addEventListener("submit", (e) => this.submit(e));
      this.steps.forEach((step) => step.addEventListener("change", (e) => this.onChange(step, e)));
      this.setupAddress();
      this.restoreState();
      this.addEventListener("input", () => this.saveState());
      this.addEventListener("change", () => this.saveState());
      this.render();

      // Show the form again when the user clicks "Edit answers" on the tiers.
      document.addEventListener("reseller:edit", () => this.showSection());

      const tiersEl = document.getElementById("reseller-tiers");
      const loggedIn = this.dataset.loggedIn === "1";
      const hasCompany = this.dataset.hasCompany === "1";

      if (tiersEl && hasCompany) {
        // Logged-in dealer WITH a company → skip the form; the tiers section shows.
        this.hideSection();
      } else if (tiersEl && !loggedIn) {
        // Guest who already submitted in this browser → skip the form (the submit
        // created the customer + company, so their tiers are valid to show).
        let saved = null;
        try { saved = JSON.parse(localStorage.getItem(this.storageKey) || "null"); } catch (e) {}
        if (saved && saved.submitted) this.hideSection();
      }
      // Logged-in WITHOUT a company → keep the form visible: they must apply so a
      // customer + linked company actually get created. localStorage is ignored here.
    }

    // Hide/show the WHOLE section (intro + card), not just the form, so the
    // page swaps cleanly between the quiz and the tiers.
    section() { return this.closest(".shopify-section") || this; }
    hideSection() { this.section().style.display = "none"; }
    showSection() {
      // Reset the submit button — it was left in its loading state after a
      // successful submit, so returning via "Edit my answers" must re-enable it.
      this.setLoading(false);
      this.section().style.display = "";
      this.section().scrollIntoView({ behavior: "smooth", block: "start" });
    }

    setLoading(on) {
      this.submitBtn.disabled = on;
      if (on) {
        if (!this.submitBtn.dataset.label) this.submitBtn.dataset.label = this.submitBtn.textContent;
        this.submitBtn.innerHTML = '<span class="rq-spinner" aria-hidden="true"></span>' + (this.i18n.submitting || "Submitting…");
      } else if (this.submitBtn.dataset.label) {
        this.submitBtn.textContent = this.submitBtn.dataset.label;
      }
    }

    setupAddress() {
      this.countrySel = this.querySelector("[data-country]");
      this.provinceSel = this.querySelector("[data-province]");
      if (this.countrySel && this.provinceSel) {
        this.countrySel.addEventListener("change", () => this.fillProvinces(this.countrySel.value));
      }
    }

    // Populate the province/state dropdown with the ISO codes Shopify needs
    // (value = zone code like "ON", label = full name) for the chosen country.
    fillProvinces(country, selected) {
      if (!this.provinceSel) return;
      const REGIONS = {
        CA: [["AB","Alberta"],["BC","British Columbia"],["MB","Manitoba"],["NB","New Brunswick"],["NL","Newfoundland and Labrador"],["NS","Nova Scotia"],["NT","Northwest Territories"],["NU","Nunavut"],["ON","Ontario"],["PE","Prince Edward Island"],["QC","Quebec"],["SK","Saskatchewan"],["YT","Yukon"]],
        US: [["AL","Alabama"],["AK","Alaska"],["AZ","Arizona"],["AR","Arkansas"],["CA","California"],["CO","Colorado"],["CT","Connecticut"],["DE","Delaware"],["DC","District of Columbia"],["FL","Florida"],["GA","Georgia"],["HI","Hawaii"],["ID","Idaho"],["IL","Illinois"],["IN","Indiana"],["IA","Iowa"],["KS","Kansas"],["KY","Kentucky"],["LA","Louisiana"],["ME","Maine"],["MD","Maryland"],["MA","Massachusetts"],["MI","Michigan"],["MN","Minnesota"],["MS","Mississippi"],["MO","Missouri"],["MT","Montana"],["NE","Nebraska"],["NV","Nevada"],["NH","New Hampshire"],["NJ","New Jersey"],["NM","New Mexico"],["NY","New York"],["NC","North Carolina"],["ND","North Dakota"],["OH","Ohio"],["OK","Oklahoma"],["OR","Oregon"],["PA","Pennsylvania"],["RI","Rhode Island"],["SC","South Carolina"],["SD","South Dakota"],["TN","Tennessee"],["TX","Texas"],["UT","Utah"],["VT","Vermont"],["VA","Virginia"],["WA","Washington"],["WV","West Virginia"],["WI","Wisconsin"],["WY","Wyoming"]]
      };
      const list = REGIONS[country] || [];
      let html = '<option value="" disabled' + (selected ? "" : " selected") + ">" + (list.length ? (this.i18n.province_select || "Select a province/state") : (this.i18n.province_first || "Select a country first")) + "</option>";
      for (const r of list) {
        html += '<option value="' + r[0] + '"' + (selected === r[0] ? " selected" : "") + ">" + r[1] + "</option>";
      }
      this.provinceSel.innerHTML = html;
    }

    onChange(step, e) {
      // Reveal conditional inputs (e.g. the "Other" free-text). No auto-advance —
      // the Continue button is always available so re-selecting the same option
      // never traps the user.
      if (step.dataset.stepType !== "single") return;
      const input = e.target;
      if (input.type !== "radio") return;
      step.querySelectorAll("[data-reveal-target]").forEach((r) => {
        r.hidden = !(input.dataset.reveal && r.getAttribute("data-reveal-target") === input.dataset.reveal);
      });
      // Auto-advance single-choice steps. Continue stays visible (for Back /
      // reload / re-selecting the same option). Don't advance if a conditional
      // input (e.g. "Other") is now shown, or on the last step.
      if (step.querySelector("[data-reveal-target]:not([hidden])")) return;
      if (this.index < this.steps.length - 1) window.setTimeout(() => this.next(), 200);
    }

    render() {
      this.steps.forEach((s, i) => (s.hidden = i !== this.index));
      const step = this.steps[this.index];
      const isLast = this.index === this.steps.length - 1;
      this.backBtn.hidden = this.index === 0;
      this.submitBtn.hidden = !isLast;
      this.nextBtn.hidden = isLast;
      this.counter.textContent = (this.i18n.step || "Step [current] of [total]").replace("[current]", this.index + 1).replace("[total]", this.steps.length);
      if (this.bar) this.bar.style.width = ((this.index + 1) / this.steps.length) * 100 + "%";
      this.errorEl.hidden = true;
      if (step.dataset.stepType === "text") {
        const f = step.querySelector("input, select, textarea");
        if (f) f.focus();
      }
    }

    fail(msg, el) { this.errorEl.textContent = msg; this.errorEl.hidden = false; if (el) el.focus(); return false; }

    // Normalize a free-text phone to E.164 for Shopify (CA/US default +1). Mirrors
    // the backend so what passes here is what the server can store. Returns null
    // when it can't be normalized (e.g. a local number with no area code).
    normalizePhone(raw) {
      if (!raw) return null;
      var trimmed = String(raw).trim();
      var digits = trimmed.replace(/\D/g, "");
      if (!digits) return null;
      if (trimmed.charAt(0) === "+") return digits.length >= 8 ? "+" + digits : null;
      if (digits.length === 10) return "+1" + digits;
      if (digits.length === 11 && digits.charAt(0) === "1") return "+" + digits;
      return null;
    }

    validate() {
      const step = this.steps[this.index];
      const type = step.dataset.stepType;
      this.errorEl.hidden = true;
      if (type === "multi") {
        if (!step.querySelector("input[type=checkbox]:checked")) return this.fail(this.i18n.err_select_one || "Please select at least one option.");
        return true;
      }
      // Required MAP-policy agreement (address step) — clearer message than the browser default.
      const mapBox = step.querySelector('[name="mapAgree"]');
      if (mapBox && !mapBox.checked) return this.fail(this.i18n.map_required || "Please agree to the MAP Policy to continue.", mapBox);
      const fields = Array.from(step.querySelectorAll("input, select, textarea"));
      for (const f of fields) {
        if (f.closest("[hidden]") && !f.required) continue;
        if (!f.checkValidity()) return this.fail(f.validationMessage || this.i18n.err_complete || "Please complete this step.", f);
      }
      // Phone (optional): if the visitor entered one, it must normalize to E.164
      // so Shopify can store it — otherwise warn instead of silently dropping it.
      var phoneEl = step.querySelector('[name="phone"]');
      if (phoneEl && !phoneEl.closest("[hidden]") && phoneEl.value.trim() && !this.normalizePhone(phoneEl.value)) {
        return this.fail(this.i18n.phone_invalid || "Please enter a valid phone number with area code, e.g. (613) 555-1111.", phoneEl);
      }
      if (type === "single" && step.querySelector("input[type=radio]") && !step.querySelector("input[type=radio]:checked")) {
        return this.fail(this.i18n.err_choose || "Please choose an option.");
      }
      return true;
    }

    next() { if (this.validate() && this.index < this.steps.length - 1) { this.index++; this.render(); } }
    prev() { if (this.index > 0) { this.index--; this.render(); } }

    collect() {
      const data = {};
      const sells = [];
      this.querySelectorAll("[name]").forEach((el) => {
        if (el.name === "sellsHowOption") { if (el.checked) sells.push(el.value); return; }
        if (el.type === "radio") { if (el.checked) data[el.name] = el.value; return; }
        if (el.type === "checkbox") { data[el.name] = el.checked; return; }
        data[el.name] = el.value;
      });
      if (sells.length) data.sellsHow = sells.length >= 2 ? "both" : sells[0];
      if (typeof data.alreadySells === "string") data.alreadySells = data.alreadySells === "true";
      if (typeof data.readyToBuy === "string") data.readyToBuy = data.readyToBuy === "true";
      return data;
    }

    saveState() {
      try {
        const state = { radios: {}, checks: {}, texts: {} };
        this.querySelectorAll("[name]").forEach((el) => {
          if (el.type === "radio") { if (el.checked) state.radios[el.name] = el.value; }
          else if (el.type === "checkbox") { state.checks[el.name + "::" + el.value] = el.checked; }
          else { state.texts[el.name] = el.value; }
        });
        localStorage.setItem(this.storageKey, JSON.stringify(state));
      } catch (e) {}
    }

    restoreState() {
      let state = null;
      try { state = JSON.parse(localStorage.getItem(this.storageKey) || "null"); } catch (e) { state = null; }
      if (!state) return;
      this.querySelectorAll("[name]").forEach((el) => {
        if (el.name === "addressProvince") return; // handled after country is known
        if (el.type === "radio") { if (state.radios && state.radios[el.name] === el.value) el.checked = true; }
        else if (el.type === "checkbox") { if (state.checks && state.checks[el.name + "::" + el.value]) el.checked = true; }
        else if (state.texts && el.name in state.texts) { el.value = state.texts[el.name]; }
      });
      // Province options depend on the (restored) country — populate then select.
      if (this.countrySel && this.countrySel.value) {
        this.fillProvinces(this.countrySel.value, (state.texts && state.texts.addressProvince) || "");
      }
      // Re-open any conditional input (e.g. "Other") for a restored selection.
      this.steps.forEach((step) => {
        const checked = step.querySelector("input[type=radio]:checked");
        step.querySelectorAll("[data-reveal-target]").forEach((r) => {
          r.hidden = !(checked && checked.dataset.reveal && r.getAttribute("data-reveal-target") === checked.dataset.reveal);
        });
      });
    }

    clearState() { try { localStorage.removeItem(this.storageKey); } catch (e) {} }

    // Persist that the form was submitted (+ the resulting tier/email) so a page
    // reload shows the tiers instead of an empty quiz. Answers are kept so
    // "Edit my answers" still restores them. Editing an answer clears this flag
    // (saveState rewrites the state), so mid-edit reloads show the quiz again.
    markSubmitted(maxTier, email) {
      try {
        let state = JSON.parse(localStorage.getItem(this.storageKey) || "{}");
        if (!state || typeof state !== "object") state = {};
        state.submitted = true;
        state.maxTier = maxTier;
        state.email = email || "";
        localStorage.setItem(this.storageKey, JSON.stringify(state));
      } catch (e) {}
    }

    async submit(e) {
      e.preventDefault();
      if (!this.validate()) return;
      const payload = this.collect();
      const endpoint = this.dataset.endpoint;
      this.setLoading(true);
      try {
        let maxTier = 0;
        if (endpoint) {
          const res = await fetch(endpoint, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
          if (!res.ok) throw new Error("bad status " + res.status);
          try { const json = await res.json(); maxTier = parseInt(json.maxTier || 0, 10); } catch (e) {}
        } else {
          console.log("[reseller-qualification] no endpoint set; payload:", payload);
          maxTier = 1;
        }
        this.markSubmitted(maxTier, payload.email);
        this.setLoading(false); // reset before hiding, so the form is usable if reopened via "Edit"
        // Hand off to the tiers section if it's on the page: hide this whole
        // section and reveal the tiers. Otherwise fall back to the thank-you.
        const tiers = document.getElementById("reseller-tiers");
        if (tiers) {
          this.hideSection();
          document.dispatchEvent(new CustomEvent("reseller:qualified", { detail: { maxTier: maxTier, email: payload.email || "" } }));
        } else {
          this.form.hidden = true;
          this.successEl.hidden = false;
          this.successEl.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      } catch (err) {
        this.setLoading(false);
        this.fail(this.i18n.err_generic || "Something went wrong. Please try again.");
      }
    }
  }
  if (!customElements.get("reseller-qualification")) customElements.define("reseller-qualification", ResellerQualification);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reseller-tiers"] && !Shopify.designMode) return;
  try {
    
  class ResellerTiers extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll("[data-tier-card]"));
      try { this.i18n = JSON.parse(this.querySelector("[data-reseller-i18n]").textContent); } catch (e) { this.i18n = {}; }
      this.loginNote = this.querySelector("[data-login-note]");
      this.errorEl = this.querySelector("[data-error]");
      this.subheading = this.querySelector("[data-subheading]");
      this.loggedIn = this.dataset.loggedIn === "1";
      this.loginUrl = this.dataset.loginUrl || "/account/login";

      this.cards.forEach((card) => {
        const btn = card.querySelector("[data-add-cart]");
        if (btn) btn.addEventListener("click", () => this.onChoose(card, btn));
      });
      this.editBtn = this.querySelector("[data-edit-answers]");
      if (this.editBtn) this.editBtn.addEventListener("click", () => this.edit());

      document.addEventListener("reseller:qualified", (e) => {
        this.reveal(parseInt((e.detail && e.detail.maxTier) || 0, 10), e.detail && e.detail.email, true);
      });

      // Keep the whole section out of the layout until it's revealed (unless
      // "always show" is on for editor preview).
      if (this.hidden) this.hideSection();

      const current = parseInt(this.dataset.currentTier || "0", 10);
      const hasCompany = this.dataset.hasCompany === "1";
      if (this.loggedIn && hasCompany) {
        // Logged-in dealer WITH a company → show their tiers on load.
        this.reveal(current > 0 ? current : 1);
      } else if (!this.loggedIn) {
        // Guest who already submitted in this browser → show tiers on load (no
        // scroll). The submit created the customer + company, so this is valid.
        try {
          const saved = JSON.parse(localStorage.getItem("amp_reseller_form_v1") || "null");
          if (saved && saved.submitted) this.reveal(parseInt(saved.maxTier || 1, 10), saved.email, false);
        } catch (e) {}
      }
      // Logged-in WITHOUT a company → tiers stay hidden; the form is shown instead.
    }

    section() { return this.closest(".shopify-section") || this; }
    hideSection() { const s = this.section(); if (s) s.style.display = "none"; }

    edit() {
      // Back to the quiz: hide the tiers, tell the form section to reappear.
      this.hideSection();
      document.dispatchEvent(new CustomEvent("reseller:edit"));
    }

    reveal(maxTier, email, scroll) {
      if (!maxTier || maxTier < 1) maxTier = 1;
      this.maxTier = maxTier;
      this.cards.forEach((card) => {
        const lvl = parseInt(card.dataset.tierLevel, 10);
        const locked = lvl > maxTier;
        card.classList.toggle("is-locked", locked);
        const btn = card.querySelector("[data-add-cart]");
        const lockedMsg = card.querySelector("[data-locked-msg]");
        const rec = card.querySelector("[data-rec]");
        if (btn) btn.disabled = locked;
        if (lockedMsg) lockedMsg.hidden = !locked;
        if (rec) rec.hidden = lvl !== maxTier;
        if (!locked && !this.loggedIn) {
          if (btn) btn.textContent = this.i18n.login_unlock || "Log in to unlock pricing";
        }
      });
      if (!this.loggedIn && this.loginNote) {
        if (email) this.loginNote.textContent = "Log in with the email you used to apply — " + email + " — to activate your dealer pricing.";
        this.loginNote.hidden = false;
      }
      const s = this.section();
      if (s) s.style.display = "";
      this.hidden = false;
      // Only scroll when the user just submitted the form — never on page load.
      if (scroll) (s || this).scrollIntoView({ behavior: "smooth", block: "start" });
    }

    onChoose(card, btn) {
      // Not logged in → the discount can't apply yet; send them to log in.
      // storefront_login_url returns the customer to this page after login,
      // where the tiers re-appear (now active) via the current_tier metafield.
      if (!this.loggedIn) {
        window.location.href = this.loginUrl;
        return;
      }
      let items = [];
      try { items = JSON.parse(btn.dataset.items || "[]"); } catch (e) { items = []; }
      if (!items.length) {
        // No starter cart configured — send them to the catalog to shop; the
        // discount applies automatically at cart for their segment.
        window.location.href = btn.dataset.shopUrl || "/collections/all";
        return;
      }
      this.addToCart(items, btn);
    }

    async addToCart(items, btn) {
      const original = btn.textContent;
      btn.disabled = true;
      btn.textContent = "Adding…";
      if (this.errorEl) this.errorEl.hidden = true;

      try {
        // Integrates with the new mini-cart drawer (mini-cart-shop branch): the
        // <cart-drawer> element (rendered only when settings.cart_type == 'drawer')
        // exposes getSectionsToRender() + renderContents(parsedState), where
        // renderContents injects the sections, opens the drawer and shows the
        // "added" notice. So we ask /cart/add.js to return those sections, then
        // hand the response to renderContents. If there's no drawer, redirect to
        // the cart page. Either only happens AFTER a successful add.
        const drawer = this.dataset.cartType === "drawer" ? document.querySelector("cart-drawer") : null;
        const body = { items: items };
        if (drawer && typeof drawer.getSectionsToRender === "function") {
          body.sections = drawer.getSectionsToRender().map((s) => s.id);
          body.sections_url = window.location.pathname;
        }
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(body),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error((data && data.description) || ("cart add failed " + res.status));
        if (drawer && typeof drawer.renderContents === "function") {
          drawer.renderContents(data); // renders sections, opens the drawer, shows the added notice
          btn.disabled = false;
          btn.textContent = original;
        } else {
          window.location.href = "/cart";
        }
      } catch (err) {
        btn.disabled = false;
        btn.textContent = original;
        if (this.errorEl) { this.errorEl.textContent = (this.i18n.add_error || "Sorry, we couldn't add those to your cart. ") + (err && err.message ? err.message : "Please try again."); this.errorEl.hidden = false; }
      }
    }
  }
  if (!customElements.get("reseller-tiers")) customElements.define("reseller-tiers", ResellerTiers);

  } catch(e) { console.error(e); }
})();
})();
